import { useState } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

import { ProductImportJob } from "../../../types/product-import-job";
import config from "../../../config";

function ProductImport() {
  const navigate = useNavigate();
  const intl = useIntl();
  const { docsDomain } = config;
  const [step, setStep] = useState(1);
  const [job, setJob] = useState<ProductImportJob | null>(null);

  return (
    <div className="components-preview wide-md mx-auto">
      <div className="nk-block-head nk-block-head-lg d-flex justify-content-between">
        <div className="nk-block-head-content wide-sm">
          <div className="nk-block-head-sub">
            <a role="button" className="back-to" onClick={() => navigate(-1)}>
              <em className="icon ni ni-arrow-left" />
              <span>
                <FormattedMessage id="productListTitle" />
              </span>
            </a>
          </div>
          <div className="nk-block-head-between">
            <h2 className="nk-block-title fw-normal">
              <FormattedMessage id="Import products" />
            </h2>
          </div>
          <div className="nk-block-des">
            <p>
              <FormattedMessage id="import.products.description" />
            </p>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <a
            href={`${docsDomain}/docs/guia-de-uso/negocios/importar-productos`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-info btn-sm d-flex align-items-center"
            title={intl.formatMessage({ id: "View documentation" })}
          >
            <em className="icon ni ni-help me-1"></em>
            <FormattedMessage id="Help" />
          </a>
        </div>
      </div>

      <div className="nk-stepper stepper-arrow is-horizontal">
        <div className="stepper-nav">
          <div className={`stepper-item ${step >= 1 ? "current" : ""}`}>
            <div className="stepper-icon">1</div>
            <div className="stepper-label">
              <FormattedMessage id="Upload file" />
            </div>
          </div>
          <div className={`stepper-item ${step >= 2 ? "current" : ""}`}>
            <div className="stepper-icon">2</div>
            <div className="stepper-label">
              <FormattedMessage id="Processing" />
            </div>
          </div>
          <div className={`stepper-item ${step >= 3 ? "current" : ""}`}>
            <div className="stepper-icon">3</div>
            <div className="stepper-label">
              <FormattedMessage id="Results" />
            </div>
          </div>
        </div>
      </div>

      <div className="nk-block nk-block-lg">
        {step === 1 && <Step1 setStep={setStep} setJob={setJob} />}
        {step === 2 && job && (
          <Step2 setStep={setStep} job={job} setJob={setJob} />
        )}
        {step === 3 && job && <Step3 job={job} />}
      </div>
    </div>
  );
}

export default ProductImport;
